import { render, staticRenderFns } from "./FoodBrands.vue?vue&type=template&id=7c7e5d7b&"
import script from "./FoodBrands.vue?vue&type=script&lang=js&"
export * from "./FoodBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports